export default "__VITE_ASSET__i5Z_Iq5s__"